import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { CreditCard, Download, Calendar } from 'lucide-react';

export function BillingSettings() {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="space-y-6">
      <Card className="p-6">
        <div className="flex items-center mb-6">
          <CreditCard className="w-5 h-5 mr-2 text-gray-500" />
          <h3 className="text-lg font-semibold">Current Plan</h3>
        </div>

        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <div>
              <p className="font-medium">Professional Plan</p>
              <p className="text-sm text-gray-600">$29/month • Billed monthly</p>
            </div>
            <Button variant="outline">Change Plan</Button>
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center mb-6">
          <CreditCard className="w-5 h-5 mr-2 text-gray-500" />
          <h3 className="text-lg font-semibold">Payment Method</h3>
        </div>
        
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <div className="w-8 h-5 bg-blue-600 rounded mr-3"></div>
              <div>
                <p className="font-medium">•••• •••• •••• 4242</p>
                <p className="text-sm text-gray-600">Expires 12/25</p>
              </div>
            </div>
            <Button variant="outline">Update</Button>
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center mb-6">
          <Download className="w-5 h-5 mr-2 text-gray-500" />
          <h3 className="text-lg font-semibold">Billing History</h3>
        </div>
        
        <div className="space-y-4">
          <div className="flex justify-between items-center py-2 border-b">
            <div>
              <p className="font-medium">December 2024</p>
              <p className="text-sm text-gray-600">Professional Plan</p>
            </div>
            <div className="text-right">
              <p className="font-medium">$29.00</p>
              <Button variant="ghost" size="sm">Download</Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
} 